import { Link } from "react-router-dom";
import Classes from "./css/blog.module.css";
import Table from '../../../components/table/table';
import Chip from '@mui/material/Chip';
import { Button } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useSelector } from 'react-redux';
import { setBlogs } from "../../../store/blogsSlice";

export const Blog = () => {
	const blogs = useSelector((state) => state.blogs);

	const columns = [
        { 
			field: 'title', 
			filterable: false, 
			headerName: 'TITLE', 
			flex: 2, 
			headerClassName: 'super-app-theme--header', 
			sortable: false
		},
        {
            field: 'status',
            headerName: 'STATUS',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            filterable: false,
            sortable: false,
            flex: 1,
            renderCell: (params) => (
                params.value !== "active" ? (
                    <Chip color="error" size="small" label={params.value} />
                ) : (
                    <Chip color="success" size="small" label={params.value} />
                )
            )
        },
	]

	return (
		<>
			<div className={Classes.Container}>
				<div className={Classes.UsersHead}>
					<Link to="/blog/createBlog">
						<Button startIcon={<AddIcon />} variant="contained" color="primary">
							Create
						</Button>
					</Link>
				</div>

				<div className='d-none d-md-block' >
					<Table
						columns={columns}
						dataPosition={"blogs"}
						endpoint={`/blogs`}
						rowId={'id'}
						navigateOnRowClickEndpoint={"/blog"}
						version="version-1"
						service={'blog'}
						tabName={'Blog'}
						setData={setBlogs}
						data={blogs}
						clickable={true}
						mobileResponsive={true}
					/>
				</div>
			</div>
		</>
	);
};
